/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Model_Download_On_First_UseInputs */



/**
* | output |
* | --- |
* | "Model will be downloaded on first use" |
*
* @param {Offline_Sync_Model_Download_On_First_UseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_model_download_on_first_use = /** @type {((inputs?: Offline_Sync_Model_Download_On_First_UseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Model_Download_On_First_UseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le modèle sera téléchargé lors de la première utilisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Modell wird bei der ersten Verwendung heruntergeladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il modello verrà scaricato al primo utilizzo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Модель будет загружена при первом использовании")
	if (locale === "es") return /** @type {LocalizedString} */ ("El modelo se descargará en el primer uso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("模型将在首次使用时下载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("モデルは初回利用時にダウンロードされます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहली बार उपयोग पर मॉडल डाउनलोड किया जाएगा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O modelo será transferido na primeira utilização")
	return /** @type {LocalizedString} */ ("Model will be downloaded on first use")
});